import type { ReactNode } from 'react';
import { WebDialog } from './WebDialog.web';

export type WebShareDialogAction = {
  id: string;
  label: string;
  icon: ReactNode;
  onClick: () => void;
};

interface WebShareDialogProps {
  visible: boolean;
  title: string;
  onClose: () => void;
  preview: ReactNode;
  actions: WebShareDialogAction[];
  footer?: ReactNode;
  maxWidth?: number;
}

export function WebShareDialog({
  visible,
  title,
  onClose,
  preview,
  actions,
  footer,
  maxWidth = 760,
}: WebShareDialogProps) {
  return (
    <WebDialog visible={visible} title={title} onClose={onClose} maxWidth={maxWidth}>
      <div style={{ display: 'grid', gap: 14, paddingTop: 8 }}>
        {preview}
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: 10 }}>
          {actions.map((action) => (
            <button
              key={action.id}
              type="button"
              onClick={action.onClick}
              style={{
                border: 'none',
                background: 'transparent',
                padding: 0,
                margin: 0,
                display: 'grid',
                justifyItems: 'center',
                gap: 8,
                flex: '1 1 120px',
                cursor: 'pointer',
              }}
            >
              {action.icon}
              <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--tabbio-text-secondary)' }}>
                {action.label}
              </span>
            </button>
          ))}
        </div>
        {footer}
      </div>
    </WebDialog>
  );
}
